<script>
  import { Input } from 'element-ui'
  export default {
    name: 'FormItemInput',
    extends: Input,
    props: {
      clearable: { type: Boolean, default: true },
    },
    methods: {
      getDisplayValue() {
        return this.value
      },
    },
  }
</script>
